<template>
  <transition name="fade" mode="out-in">
    <div v-if="resource.ready && selects.ready">
      <div class="card mb-5">
        <div class="card-title" v-once>
          <span v-if="editing">Товар – {{ entry.name }}</span>
          <span v-else>Создать товар</span>
        </div>

        <form class="spaced-y-4" @submit.prevent="submit">
          <div class="flex -mx-2">
            <text-field
                class="w-1/2 px-2"
                title="Название"
                v-model="entry.name"
                :errors="errors.name"
                required
            />

            <select-field
                class="w-1/2 px-2"
                title="Категория"
                label="name"
                valueName="id"
                :clearable="false"
                :options="selects.categories"
                v-model="entry.category_id"
                :errors="errors.category_id"
            />
          </div>
          <div v-if="entry.category_id === 1" class="flex -mx-2">
            <select-field
                class="w-1/2 px-2"
                title="Тональность"
                label="name"
                valueName="id"
                :clearable="false"
                :options="selects.tonalities"
                v-model="entry.instrument_tonality_id"
                :errors="errors.instrument_tonality_id"
            />
            <select-field
                class="w-1/2 px-2"
                title="Строй"
                label="name"
                valueName="id"
                :clearable="false"
                :options="selects.tuning"
                v-model="entry.instrument_tune_id"
                :errors="errors.instrument_tune_id"
            />
            <select-field
                class="w-1/2 px-2"
                title="Сталь"
                label="name"
                valueName="id"
                :clearable="false"
                :options="selects.steel"
                v-model="entry.instrument_steel_id"
                :errors="errors.instrument_steel_id"
            />
            <select-field
                class="w-1/2 px-2"
                title="Многонотник"
                label="name"
                valueName="id"
                :clearable="false"
                :options="selects.polynote"
                v-model="entry.instrument_polynote_id"
                :errors="errors.instrument_polynote_id"
            />
          </div>

          <textarea-field
              title="Описание"
              v-model="entry.description"
              :errors="errors.description"
          />
          <text-field
              title="Комментарий"
              v-model="entry.comment"
              :errors="errors.name"
              required
          />


          <div class="flex -mx-2">
            <text-field
                type="number"
                class="w-1/2 px-2"
                title="Стоимость"
                v-model="entry.price"
                :errors="errors.price"
                required
            />

            <text-field
                v-if="
                                editing ||
                                (entry.category_id &&
                                    selects.categories.find(
                                        (category) =>
                                            category.id === entry.category_id
                                    ).is_unique)
                            "
                class="w-1/2 px-2"
                title="Уникальный ID"
                v-model="entry.unique_id"
                :errors="errors.unique_id"
                required
            />
          </div>

          <div class="flex -mx-2">
            <text-field
                v-if="
                                entry.category_id &&
                                !selects.categories.find(
                                    (category) =>
                                        category.id === entry.category_id
                                ).is_unique
                            "
                type="number"
                class="w-1/2 px-2"
                title="В наличии"
                v-model="entry.amount"
                :errors="errors.amount"
                required
            />

            <select-field
                class="w-1/2 px-2"
                title="Статус"
                label="label"
                valueName="name"
                :clearable="false"
                :options="statuses"
                v-model="entry.status"
                :errors="errors.status"
            />
          </div>

          <div class="flex -mx-2">
            <select-field
                class="w-1/2 px-2"
                title="Филиал"
                label="name"
                valueName="id"
                :clearable="true"
                :options="selects.branches"
                v-model="entry.branch_id"
                :errors="errors.branch_id"
            />
          </div>

<!--          <div class="flex -mx-2">
            <select-field
                class="w-1/2 px-2"
                title="Воронка amoCRM"
                label="name"
                valueName="id"
                :clearable="true"
                :options="selects.pipelines"
                @input="setPipeline"
                v-model="pipeline_id"
            />

            <select-field
                v-if="pipeline && pipeline.id"
                class="w-1/2 px-2"
                title="Статус amoCRM"
                label="name"
                valueName="id"
                :clearable="true"
                :options="pipeline.statuses"
                v-model="entry.status_id"
            />
          </div>-->

          <div
              class="mb-2 font-semibold"
              v-if="editing && entry.category.rentable"
          >
            Выручка с аренды:
            {{ entry.revenue ? entry.revenue : 0 }} ₽
          </div>

          <hr class="mb-3"/>

          <div
              class="inline-block"
              v-if="!editing || can('edit-product')"
          >
            <button class="btn btn-primary">Сохранить</button>

            <button
                @click.prevent="showAddModal = true"
                class="btn btn-success"
            >
              Добавить
            </button>

            <button
                v-if="editing && can('remove-product')"
                @click.prevent="destroy"
                class="btn btn-danger"
            >
              Удалить
            </button>
          </div>

          <div class="inline-block" v-if="editing" v-once>
            <router-link
                tag="button"
                v-if="
                                entry.status === 'stock' && can('manage-orders')
                            "
                :to="{
                                name: 'admin.billing.orders.create',
                                params: {
                                    productId: entry.id,
                                },
                            }"
                class="btn btn-blue"
            >Продать
            </router-link
            >

            <router-link
                tag="button"
                v-if="
                                entry.status === 'stock' &&
                                entry.category.rentable &&
                                can('manage-rentals')
                            "
                :to="{
                                name: 'admin.billing.rentals.create',
                                params: {
                                    productId: entry.id,
                                },
                            }"
                class="btn btn-warning"
            >Сдать в аренду
            </router-link
            >
          </div>
        </form>
      </div>

      <order v-if="editing && entry.order" :order="entry.order"/>
      <rentals v-if="editing && entry.category.rentable"/>
      <transactions
          v-if="can('access-transactions') && editing"
          modelType="product"
          :modelId="entry.id"
      />
      <activity
          modelType="product"
          :modelId="entry.id"
          :attributes="logAttributes"
          v-if="can('access-activity-log') && editing"
      />
      <add-modal
          v-if="editing"
          @success="fetch"
          :id="entry.id"
          :show.sync="showAddModal"
      />
    </div>
  </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import Order from "./order";
import Rentals from "./rentals";
import Transactions from "@/views/admin/billing/transactions/index";
import Activity from "@/views/admin/activity/index";
import AddModal from "./add";

export default {
  extends: ResourceForm,

  components: {
    Order,
    Rentals,
    Transactions,
    Activity,
    AddModal,
  },

  data() {
    return {
      canUpdate: this.can("edit-product"),
      showAddModal: false,
      logAttributes: {
        status: {
          label: "Статус",
          values: {
            stock: "В наличии",
            rent: "Аренда",
            sold: "Продан",
            on_way: "На пути с маркетплейса",
            fbo: "На пути с маркетплейса",
          },
        },
        unique_id: {
          label: "ID",
        },
        name: {
          label: "Название",
        },
        price: {
          label: "Стоимость",
        },
        amount: {
          label: "Количество",
        },
      },
      resource: {
        name: "admin.products",
        endpoint: "admin/products",
      },

      entry: {
        amount: 1,
      },

      selects: {
        ready: false,
        categories: [],
        branches: [],
        pipelines: [],
        steel: [],
        tonalities: [],
        tuning: [],
        polynote: [],
      },

      pipeline_id: null,
      pipeline: {},
    };
  },

  methods: {
    setPipeline() {
      this.pipeline = this.selects.pipelines.find(
          (pipeline) => pipeline.id == this.pipeline_id
      );
    },

    async fetchSelects() {
      await axios
          .get("/admin/instruments")
          .then((response) => {
            const data = response.data;
            this.selects.tonalities = data.tonalities;
            this.selects.steel = data.steel;
            this.selects.tuning = data.tuning;
            this.selects.polynote = data.polynote
          });

      await axios
          .get("/admin/products/categories/all")
          .then((response) => {
            this.selects.categories = response.data.data;
          });

      await axios.get("/admin/branches/all").then((response) => {
        this.selects.branches = response.data.data;
      });

      await axios.get("admin/crm/settings").then((response) => {
        this.selects.pipelines = response.data.data.pipelines;
      });

      let vm = this;
      this.pipeline = this.selects.pipelines.find((pipeline) => {
        return !!pipeline.statuses.find((status) => {
          return status.id == vm.entry.status_id;
        });
      });

      if (this.pipeline) {
        this.pipeline_id = this.pipeline.id;
      }

      this.selects.ready = true;
    },
  },

  mounted() {
    this.fetchSelects();
  },
  computed: {
    statuses() {
      return [
        {
          name: "stock",
          label: "В наличии",
          available: true
        },
        {
          name: "book",
          label: "Забронирован",
          available: true
        },
        {
          name: "rent",
          label: "В аренде",
          available: this.entry.rentals_count > 0
        },
        {
          name: "sold",
          label: "Продан",
          available: true
        },
        {
          name: "on_way",
          label: "На пути с маркетплейса",
          available: true
        },
        {
          name: "fbo",
          label: "ФБО",
          available: true
        },
      ].filter((status) =>  status.available)
    }
  }
};
</script>
